var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{staticClass:"about-page"},[_c('h2',[_vm._v("About this project")])])}
var staticRenderFns = []

export { render, staticRenderFns }